export default {"src":"/bnb/_next/static/media/midas-dark.d06acfd5.svg","height":176,"width":153};